<template>
  <div>
    <app-header :usuario="usuario"></app-header>
    <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>



<script>
import Header from "./components/Header.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      usuario: {}
    };
  },
  components: {
    appHeader: Header
  },
  computed: {
    ...mapGetters(["categorias", "pathAPI", "userLogged", "counter"])
  },
  methods: {
    buscarT(token) {
      fetch(this.pathAPI + "token.php?token=" + token)
        .then(response => response.json())
        .then(data => {
          console.log("buscando token")
          console.log(data.usuario);

          this.$store.state.userLogged.user = data.usuario;
          var urlLogin = "/#/Login/" + token;
          this.$router.push({ path: urlLogin});
          window.open(urlLogin, "_self");
        });
    },
    buscarCategorias() {
      fetch(this.pathAPI + "categorias.php?usuario=aplicacion")
        .then(response => response.json())
        .then(data => {
          this.$store.state.categorias = [];
          data.forEach(element => {
            this.$store.state.categorias.push({
              id: element.id_categoria,
              nombre: element.descripcion,
              imagen: element.imagen_categoria,
              styleObject: { backgroundColor: element.color },
              color: element.color.substr(1, 6),
              video: element.link_video,
              estado: element.estado
            });
          });
        });
    }
  },
  created: function() {
    console.log("t - " + sessionStorage.getItem("t"));
    if (sessionStorage.getItem("t")) {
      //this.buscarT(sessionStorage.getItem("t"));
    }

    this.usuario.userLogged = this.userLogged;
    this.buscarCategorias();
    if (this.userLogged.profile == "HIJO") {
      this.buscarPerfil();
    }
  }
};
</script>

<style>
.form-control {
  border-radius: 10px;
  height: 45px;
  color: #2c1538;
}

label {
  margin-bottom: 4px;
  font-size: medium;
}

.categoria {
  margin: 10px;
  border-radius: 15px !important;
  border: 0px !important;
  width: 250px;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  cursor: pointer;
}
.categoria:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Patua One", cursive;
}

.alert-danger {
  color: #721c24c7;
  background-color: #ff00171a;
  border-radius: 10px;
}

.boton-primario {
  margin: 5px;
  padding: 5px 20px;
  border-radius: 20px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  cursor: pointer;
  font-size: 20px;
  background-color: #9546af;
  font-family: "Patua One", cursive;
  color: white;
}
.boton-primario:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
  background-color: #dd3260;
  color: white;
}

.boton-secundario {
  margin: 5px;
  padding: 5px 20px;
  border-radius: 20px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  cursor: pointer;
  font-size: 20px;
  background-color: #757575;
  font-family: "Patua One", cursive;
  color: white;
}
.boton-secundario:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
  background-color: #616161;
  color: white;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid rgb(2, 171, 177);
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: rgb(2, 171, 177) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loader {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
}
.loader.hidden {
  animation: fadeOut 1.5s;
  animation-fill-mode: forwards;
  width: 100%;
  height: 100%;
  transition: height 1s;
}

@keyframes fadeOut {
  100% {
    opacity: 0;
    visibility: hidden;
  }
}

.slideAnim-enter {
  opacity: 0;
}

.slideAnim-enter-active {
  animation: 0.5s ease-out forwards;
  transition: opacity 0.5s;
}

.slideAnim-leave-active {
  animation: 0.5s ease-out forwards;
  transition: opacity 0.5s;
  opacity: 0;
}

.slide-enter-active {
  animation: slide-in 100ms ease-out forwards;
}
.slide-leave-active {
  animation: slide-out 100ms ease-out forwards;
}
@keyframes slide-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slide-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.modal-arkidia {
  text-align: center;
  padding: 10px;
  margin-top: 30px;
  width: 600px;
  min-height: 300px;
  max-width: 400px;
}
@media screen and (max-width: 600px) {
  .modal-arkidia {
    width: 300px;
    max-width: 250px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue